module.exports = __webpack_public_path__ + "components/flag/static/square/sv-f9ad9e16a67e2c1d0b852456ceb6afd8.svg";